"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewColumnsController", {
    enumerable: true,
    get: function() {
        return ViewColumnsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _viewcolumnsservice = require("~/services/view-columns.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ViewColumnsController = class ViewColumnsController {
    async columnList(context, viewId) {
        return new _PagedResponse.PagedResponseImpl(await this.viewColumnsService.columnList(context, {
            viewId
        }));
    }
    async columnAdd(context, viewId, body, req) {
        const viewColumn = await this.viewColumnsService.columnAdd(context, {
            viewId,
            column: body,
            req
        });
        return viewColumn;
    }
    async viewColumnUpdate(context, viewId, columnId, body, req) {
        const result = await this.viewColumnsService.columnUpdate(context, {
            viewId,
            columnId,
            column: body,
            req
        });
        return result;
    }
    async viewColumnUpdateV3(context, req, viewId, body) {
        return new _PagedResponse.PagedResponseImpl(await this.viewColumnsService.columnsUpdate(context, {
            viewId,
            columns: body,
            req
        }));
    }
    async viewColumnListV3(context, req, viewId) {
        return {
            [_nocodbsdk.APIContext.VIEW_COLUMNS]: await this.viewColumnsService.viewColumnList(context, {
                viewId,
                req
            })
        };
    }
    constructor(viewColumnsService){
        this.viewColumnsService = viewColumnsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/views/:viewId/columns/',
        '/api/v2/meta/views/:viewId/columns/'
    ]),
    (0, _extractidsmiddleware.Acl)('columnList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewColumnsController.prototype, "columnList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/columns/',
        '/api/v2/meta/views/:viewId/columns/'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('columnAdd'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ViewColumnReqType === "undefined" ? Object : _nocodbsdk.ViewColumnReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewColumnsController.prototype, "columnAdd", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/views/:viewId/columns/:columnId',
        '/api/v2/meta/views/:viewId/columns/:columnId'
    ]),
    (0, _extractidsmiddleware.Acl)('viewColumnUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Param)('columnId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_param(4, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _nocodbsdk.ViewColumnReqType === "undefined" ? Object : _nocodbsdk.ViewColumnReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewColumnsController.prototype, "viewColumnUpdate", null);
_ts_decorate([
    (0, _common.Patch)('/api/v3/meta/views/:viewId/columns'),
    (0, _extractidsmiddleware.Acl)('columnUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewColumnsController.prototype, "viewColumnUpdateV3", null);
_ts_decorate([
    (0, _common.Get)('/api/v3/meta/views/:viewId/columns'),
    (0, _extractidsmiddleware.Acl)('columnList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        void 0,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewColumnsController.prototype, "viewColumnListV3", null);
ViewColumnsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _viewcolumnsservice.ViewColumnsService === "undefined" ? Object : _viewcolumnsservice.ViewColumnsService
    ])
], ViewColumnsController);
